
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PasswordField } from "./shared/PasswordField";
import { usePasswordValidation } from "@/hooks/auth/use-password-validation";

interface UpdatePasswordFormProps {
  password: string;
  setPassword: (value: string) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  isLoading: boolean;
}

export const UpdatePasswordForm = ({
  password,
  setPassword,
  onSubmit,
  isLoading,
}: UpdatePasswordFormProps) => {
  const [confirmPassword, setConfirmPassword] = useState("");
  const { passwordError, validatePasswordMatch } = usePasswordValidation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validatePasswordMatch(password, confirmPassword)) {
      await onSubmit(e);
    }
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-white">Set New Password</h3>
        <p className="text-sm text-gray-300">
          Please enter your new password.
        </p>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <PasswordField 
            value={password}
            onChange={setPassword}
            placeholder="New Password"
            minLength={6}
          />
          
          <PasswordField 
            value={confirmPassword}
            onChange={setConfirmPassword}
            placeholder="Confirm New Password"
            minLength={6}
          />
          
          {passwordError && (
            <div className="text-red-400 text-sm">{passwordError}</div>
          )}
          
          <Button
            type="submit"
            className="w-full bg-gameGold text-gamePurple hover:bg-gameGold/90 mt-2"
            disabled={isLoading}
          >
            {isLoading ? "Updating Password..." : "Update Password"}
          </Button>
        </div>
      </form>
    </div>
  );
};
